﻿module Illy.SafeStack.Client.FontAwesome

open Fable.React
open Fable.React.Props

let private fa cls (attr: seq<IHTMLProp>) = 
    let list = attr |> List.ofSeq
    let class' = ClassName cls :> IHTMLProp
    i (class'::list) []

type Style =
    | Regular
    | Light
    | Solid
    member this.toString() =
        match this with
        | Regular -> "far"
        | Light -> "fal"
        | Solid -> "fas"

type Size =
    | LG
    | XS
    | SM
    | Normal
    | X2
    | X3
    | X4
    | X5
    | X6
    | X7
    | X8
    | X9
    | X10
    member this.toString() =
        match this with
        | LG -> "fa-lg"
        | XS -> "fa-xs"
        | SM -> "fa-sm"
        | Normal -> "fa-1x"
        | X2 -> "fa-2x"
        | X3 -> "fa-3x"
        | X4 -> "fa-4x"
        | X5 -> "fa-5x"
        | X6 -> "fa-6x"
        | X7 -> "fa-7x"
        | X8 -> "fa-8x"
        | X9 -> "fa-9x"
        | X10 -> "fa-10x"

type Position =
    | Left
    | Right
    member this.toString() =
        match this with
        | Left -> "fa-pull-left"
        | Right -> "fa-pull-right"

type Animation =
    | Pulse
    | Spin
    member this.toString() =
        match this with
        | Pulse -> "fa-pulse"
        | Spin -> "fa-spin"

type Rotation =
    | R90
    | R180
    | R270
    member this.toString() =
        match this with
        | R90 -> "fa-rotate-90"
        | R180 -> "fa-rotate-180"
        | R270 -> "fa-rotate-270"

type Flip =
    | Horizontal
    | Vertical
    member this.toString() =
        match this with
        | Horizontal -> "fa-flip-horizontal"
        | Vertical -> "fa-flip-vertical"

type Stacking =
    | Stack
    | Stack1
    | Stack2
    member this.toString() =
        match this with
        | Stack -> "fa-stack"
        | Stack1 -> "fa-stack-1x"
        | Stack2 -> "fa-stack-2x"

type Modifier =
    | Style of Style
    | Fixed
    | Size of Size
    | List
    | Border
    | Position of Position
    | Animate of Animation
    | Rotate of Rotation
    | Flip of Flip
    | Stack of Stacking
    | Attributes of seq<IHTMLProp>
    member this.toString() =
        match this with
        | Style style -> style.toString()
        | Fixed -> "fa-fw"
        | Size size -> size.toString()
        | List -> "fa-li"
        | Border -> "fa-border"
        | Position position -> position.toString()
        | Animate animation -> animation.toString()
        | Rotate rotation -> rotation.toString()
        | Flip flip -> flip.toString()
        | Stack stacking -> stacking.toString()
        | Attributes _ -> ""

let private calcClass name (modifiers: Modifier list) =
    modifiers 
    |> List.fold (fun acc x -> 
        match x with
        | Attributes _ -> acc
        | x -> x.toString()::acc
    ) [("fa-" + name)]
    |> List.rev
    |> String.concat " "

let icon name modifiers = fa (calcClass name modifiers)
let solid name modifiers = icon name (Style Solid::modifiers)
let regular name modifiers = icon name (Style Regular::modifiers)
let light name modifiers = icon name (Style Light::modifiers)